import editCargoForm from './editCargoFormModel';
const {
  formField: {
    // DATOS CARGO 
    e_name,
    e_description,
    e_area,
    e_visita_domiciliaria,
    e_prueba_psicotecnica,
    e_examen_alimentos,
    e_examen_alturas,
    e_certificado_laboral,
    e_certificado_estudios,
    e_adres,
    e_antecedentes_judicial,
    e_entrevista,
    e_sociodemografica,
    e_dme,
    e_sst,
  } 
} = editCargoForm;

export default {
  [e_name.name]: '',
  [e_description.name]: '',
  [e_area.name]: null,
  [e_visita_domiciliaria.name]: false,
  [e_prueba_psicotecnica.name]: false,
  [e_examen_alimentos.name]: false,
  [e_examen_alturas.name]: false,
  [e_certificado_laboral.name]: false,
  [e_certificado_estudios.name]: false,
  [e_adres.name]: false,
  [e_antecedentes_judicial.name]: false,
  [e_entrevista.name]: false,
  [e_sociodemografica.name]: false,
  [e_dme.name]: false,
  [e_sst.name]: false,
};

